<script setup lang="ts">
import { HaskoningDialog } from "@haskoning/vue-component-library";

import type { PendingReceiveWrite } from "../composables/useReceiveSpeckleProfile";

const TASK_PANE_DIALOG_VIEWPORT_MARGIN = "48px";
const TASK_PANE_DIALOG_MIN_WIDTH = 0;
const TASK_PANE_DIALOG_MAX_WIDTH = `calc(100vw - ${TASK_PANE_DIALOG_VIEWPORT_MARGIN})`;
const TASK_PANE_DIALOG_WIDTH_DEFAULT = `min(420px, calc(100vw - ${TASK_PANE_DIALOG_VIEWPORT_MARGIN}))`;

defineProps<{
  modelValue: boolean;
  pendingWrite: PendingReceiveWrite | null;
  loading: boolean;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: boolean];
  cancel: [];
  confirm: [];
}>();

function updateModelValue(value: boolean): void {
  emit("update:modelValue", value);
}

function handleCancel(): void {
  emit("cancel");
}

function handleConfirm(): void {
  emit("confirm");
}
</script>

<template>
  <HaskoningDialog
    :model-value="modelValue"
    title="Overwrite the target range?"
    :min-width="TASK_PANE_DIALOG_MIN_WIDTH"
    :width="TASK_PANE_DIALOG_WIDTH_DEFAULT"
    :max-width="TASK_PANE_DIALOG_MAX_WIDTH"
    :persistent="loading"
    scrollable
    show-actions
    primary-action-text="Replace"
    secondary-action-text="Cancel"
    :primary-action-loading="loading"
    :secondary-action-disabled="loading"
    @update:model-value="updateModelValue"
    @secondary-action-click="handleCancel"
    @primary-action-click="handleConfirm"
  >
    <p>
      Receive will write an editable Excel form into
      <strong>{{ pendingWrite?.target.targetAddress ?? "the selected range" }}</strong
      >.
    </p>

    <p v-if="pendingWrite?.nonEmptyCellCount" class="mt-2">
      That range contains
      <strong>{{ pendingWrite.nonEmptyCellCount }}</strong>
      non-empty {{ pendingWrite.nonEmptyCellCount === 1 ? "cell" : "cells" }}. Continuing will overwrite that data.
    </p>
  </HaskoningDialog>
</template>
